<template>
  <div class="flex items-center bg-white border border-gray-200 rounded-xl p-4 custom-shadow">
    <div class="w-full">
      <p class="mb-4 text-lg font-semibold">Карта учебных заведений</p>
      <div id="map" style="width: 100%; height: 500px;"></div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted } from 'vue';

export default defineComponent({
  name: 'YandexMap',
  props: {
    center: {
      type: Array,
      required: true,
      default: () => [55.751574, 37.573856]
    },
    markers: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  setup(props) {
    onMounted(() => {
      if (!window.ymaps) {
        console.error('Yandex Maps API не загружен');
        return;
      }
      window.ymaps.ready(() => initMap(props.markers));
    });

    const initMap = (markers) => {
      var myMap = new window.ymaps.Map("map", {
            center: props.center,
            zoom: 10
        }, {
            searchControlProvider: 'yandex#search'
        });        

      markers.forEach(marker => {
        myMap.geoObjects.add(new window.ymaps.Placemark(marker.coordinates, {
          balloonContent: marker.description
        }, {
          preset: 'islands#circleIcon',
          iconColor: '#1E40AF'
        }));
      });
    };
  }
});
</script>

<style scoped>
#map {
  width: 100%;
  height: 500px;
}
</style>
